import {PaymentPlan} from '../../../shared-gen/Payment/Rules/PaymentPlan';
import {CreditFun} from '../../model/financial/credit.fun';

export class PaymentPlanFun {
    
    static createEmpty(): PaymentPlan {
        return {
            OrderItemsPaidCredit: [],
            PaidCredit: CreditFun.none(),
            RemainingCredit: CreditFun.none(),
            MissingCents: 0,
            IsPaid: false
        }
    }
    
}
